import React from "react";

const AppHeader = ({ children }) => {
  return <header id="topBar">{children}</header>;
};

export default AppHeader;
